import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { decodeBase64ToText, encodeToBase64, formatDate } from '../../utility';
import { ApiService } from '../../api.service';
import { Outcome } from '../../outcome/outcome.service';
import { Subscription } from 'rxjs';
import { ToastService } from '../services/toast.service';
import { AuthService } from '../../auth/auth.service';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../environments/environment';
import { HttpService } from '../services/http.service';
import { WizardComponent } from '../quick-action/wizard/wizard.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { IsOwnerPipe } from '../../work-package/pipes/is-owner.pipe';
import { HelperService } from '../services/helper.service';
import { SidebarService } from '../services/sidebar.service';
import { FilterByPlacePipe } from '../../work-package/pipes/filter-by-place.pipe';
import { IsMemberPipe } from '../../work-package/pipes/is-member.pipe';
import { IsBacklogExistPipe } from '../../work-package/pipes/is-backlog-exist.pipe';

@Component({
  selector: 'app-annual-outcome',
  templateUrl: './annual-outcome.component.html',
  styleUrl: './annual-outcome.component.css',
  providers: [FilterByPlacePipe, IsMemberPipe, IsBacklogExistPipe]
})
export class AnnualOutcomeComponent {
  @Input() outcomeData: any; // Adjust the type as needed
  @Output() outcomeDetailData = new EventEmitter<any>();
  @Output() notifyParent = new EventEmitter<string>();
  @Input() index: number;
  private roleSubscription: Subscription;
  private outcomeService = inject(Outcome);
  private helper = inject(HelperService);
  private toastService = inject(ToastService);
  private httpService = inject(HttpService);
  public dialogService = inject(DialogService);
  public sidebarService = inject(SidebarService);
  private apiService = inject(ApiService);
  private cookieService = inject(CookieService);
  private isOwnerPipe = inject(IsOwnerPipe);
  private filterByPlacePipe = inject(FilterByPlacePipe);
  private isMemberPipe = inject(IsMemberPipe);
  private isBacklogExistPipe = inject(IsBacklogExistPipe);

  userData: any;
  outcomeId: any = '';
  cat: any;
  isOpenTerminateModal: boolean = false;
  detailOutcomeData: any = [];
  isShowOutcomes: boolean = false;
  countInputs: number;
  ngOnInit(): void {
    const decodedData = window.atob(this.cookieService.get('auth'));
    this.userData = JSON.parse(decodedData);

    this.roleSubscription = this.apiService.role$.subscribe((data) => {
      this.cat = data;
    });

    this.countInputs = this.countPlaceholders(this.outcomeData?.value);
    this.prefillInputs();
  }
  isModalOpen = false;
  isEditing: boolean = false;
  currentOutcome: any;

  openModal(index: any) {
    this.currentOutcome = { ...this.outcomeData[index] };
    if (this.countInputs == 0) {
      return this.toastService.error('This MTO does not have dynamic values.');
    }
    this.isModalOpen = true;
  }

  showActionMenu(): any {
    if (this.cat) {
      if (['affiliate', 'iel', 'lead'].includes(this.cat)) {
        return true;
      } else {
        if (this.outcomeData?.outcome_type != 'affiliate') {
          if (this.outcomeData?.outcome_type !== 'individual') {
            if (this.filterByPlacePipe.transform(this.outcomeData?.members, 'owners, managers, supers' )
              .filter((x: { user_id: any; }) => x.user_id == this.userData?.data?.user_id).length > 0) {
              return true;
            } else {
              return this.isBacklogExistPipe.transform(this.outcomeData, this.userData?.data?.user_id);
            }
          } else {
            return this.outcomeData?.accountable === this.userData?.data?.user_id;
          }
        } else {
          return false;
        }
      }
    }
    return false;
  }
  

  prefillInputs() {
    this.inputValues = [];
    try {
      const parsedValues = JSON.parse(this.outcomeData?.outcome_values);
      if (Array.isArray(parsedValues) && parsedValues.length > 0) {
        for (let data of parsedValues) {
          this.inputValues.push(String(data));
        }
      } else {
      }
    } catch (error) {
      console.error("Error parsing outcome_values:", error);
    }
  }
  

  fillPlaceholders(str: any, values: any[]) {
    for (let i = 0; i < values.length; i++) {
      str = str.replace('___', values[i]);
    }
    return str;
  }

  saveOutcome() {
    this.httpService
      .post(`${environment.opbBackendHost}/api/${this.cat}/outcomes/update`, {
        values: this.inputValues,
        value:this.fillPlaceholders(
          this.outcomeData?.value,
          this.inputValues
        ),
        outcome_id: this.outcomeData?.outcome_id,
      })
      .subscribe((response: any) => {
        if(response?.error) {
          this.toastService.error(response?.message);
          this.inputValues = [];
        } else {
          this.outcomeData.value = this.fillPlaceholders(
            this.outcomeData?.value,
            this.inputValues
          );
          this.toastService.success(response?.message);
        }
        this.closeModal();
      });
  }

  closeModal() {
    this.isModalOpen = false;
    this.currentOutcome = null;
  }

  inputValues: string[] = [];
  countPlaceholders(inputString: any) {
    const placeholderRegex = /___/g;
    const matches = inputString.match(placeholderRegex);
    return matches ? matches.length : 0;
  }


  openTerminateModal() {
    // this.outcomeData?.accountable != this.userData?.data?.user_id || 
    if(this.outcomeData?.accountable != this.userData?.data?.user_id){
      return this.toastService.error('Not authorized')
    }
    this.isOpenTerminateModal = true;
  }

  closeTerminateModal() {
    this.isOpenTerminateModal = false;
  }

  terminateTrigger() {
    this.terminateOutcome(this.cat);
  }

  terminateOutcome(cat: any) {
    const payload = { outcome_id: this.outcomeData.outcome_id };
    this.outcomeService.terminateOutcome(payload, cat).subscribe(
      (data: any) => {
        try {
          const parsedData = data;
          parsedData?.error
            ? this.toastService.error(parsedData?.message)
            : this.toastService.success(parsedData?.message);
          if(!parsedData?.error) {
            this.handleChildEvent();
          }
          this.isOpenTerminateModal = false;
        } catch (error) {
          console.error('Error parsing decoded data:', error);
          this.isOpenTerminateModal = false;
        }
      },
      (error) => {
        console.error('Error fetching users', error);
      }
    );
  }

  detailOutcome(cat: any) {
    const payload = { outcome_id: this.outcomeId };
    this.outcomeService.detailOutcome(payload, cat).subscribe(
      (data: any) => {

        try {
          const parsedData = data;
          this.outcomeDetailData.emit(parsedData?.data);
          this.detailOutcomeData = parsedData?.data;
        } catch (error) {
          console.error('Error parsing decoded data:', error);
        }
      },
      (error) => {
        console.error('Error fetching users', error);
      }
    );
  }

  handleChildEvent(event?:any) {
    this.notifyParent.emit();
  }

  clickTerminateOutcome(cat: any) {
    this.roleSubscription = this.apiService.role$.subscribe((data) => {
      this.detailOutcome(data);
    });
  }

  clickViewOutcome(cat: any) {
    this.isShowOutcomes = !this.isShowOutcomes;
    this.outcomeId = cat;
    this.roleSubscription = this.apiService.role$.subscribe((data) => {
      this.detailOutcome(data);
    });
  }

    ref: DynamicDialogRef | undefined;
  
  openWizard() {
      this.ref = this.dialogService.open(WizardComponent, {
        width: '90%',
        contentStyle: { 'max-height': '90vh', overflow: 'auto' },
        baseZIndex: 10000,
        data: {
          // Pass the custom data here
          // detailOutcomeData: this.detailOutcomeData,
          outcomeData: this.outcomeData,
          step: 0,
        },
      });

      this.ref.onClose.subscribe(() => {
        this.helper.isOutcomeDataLoad$.next(true)
    });
    }

  getLabel(status: number): string {
    switch (status) {
      case 1:
        return 'Not Started'; // Custom label for status 1
      case 2:
        return 'Ongoing'; // Custom label for status 2
      case 3:
        return 'Completed'; // Custom label for status 3
      case 4:
        return 'Delayed'; // Custom label for status 4
      case 5:
        return 'Terminated'; // Custom label for status 5
      default:
        return ''; // Default label if status is not 1, 2, or 3
    }
  }

  ngOnDestroy() {
    if (this.roleSubscription) {
      this.roleSubscription.unsubscribe(); // Clean up subscription when component is destroyed
    }
  }
}
